<script lang="ts">
	import { GaugeChart } from '@wiseed/wikit';

	export let value: number;
	export let color: string;
	export let title: string;
</script>

<GaugeChart {value} {color} {title} />
